import React, { useContext, useEffect, useState } from "react";
import "./style.scss";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useGetSkuDetail } from "../../../hooks/useSeggregation";
import { useGetAllMergedGuidelines } from "../../../hooks/useGuidelines";
import { Empty, message } from "antd";
import Button from "../../../common/Button";
import nextIcon from "../../../assets/AddSubCategory/nextIcon.svg";
import { SeggreagtionContext } from "../../../context/seggregationProvider";
import Stepper from "../../Stepper";

const SelectVariant = () => {
  const {
    segg_selectedCategory,
    segg_selectedSubCategory,
    segg_selectedMarketplace,
    segg_setSelectedMarketplace,
    segg_selectedVariant,
    segg_setSelectedVariant,
  } = useContext(SeggreagtionContext);
  const [skuFiles, setSkuFiles] = useState([]);
  const [skuDetails, setSkuDetails] = useState();
  const [angleSets, setAngleSets] = useState([]);
  const [guidelineId, setGuidelineId] = useState("");
  const [richTextHtml, setRichTextHtml] = useState("");
  const navigate = useNavigate();
  const params = useParams();

  const onSuccessGetSkuDetails = (res) => {
    if (res?.status === 200) {
      setSkuFiles(res?.data?.skuFiles);
      setSkuDetails(res?.data?.draftSku);
      setRichTextHtml(res?.data?.batch?.richTextDescriptionHtml?.url);

      // for (const marketplace of res?.data?.draftSku?.toProcessFilesDraft ||
      //   []) {
      //   if (!marketplace?.isCompleted) {
      //     segg_setSelectedMarketplace({
      //       id: marketplace?.marketplace?._id,
      //       name: marketplace?.marketplace?.name,
      //     });
      //     break;
      //   }
      // }
      const toProcess = res?.data?.draftSku?.toProcessFilesDraft || [];
      let allCompleted =
        toProcess.length > 0 && toProcess.every((m) => m?.isCompleted);

      if (allCompleted) {
        const lastMarketplace = toProcess[toProcess.length - 1];
        segg_setSelectedMarketplace({
          id: lastMarketplace?.marketplace?._id,
          name: lastMarketplace?.marketplace?.name,
        });
      } else {
        for (const marketplace of toProcess) {
          if (!marketplace?.isCompleted) {
            segg_setSelectedMarketplace({
              id: marketplace?.marketplace?._id,
              name: marketplace?.marketplace?.name,
            });
            break;
          }
        }
      }
    }
  };
  const onErrorGetSkuDetails = (err) => {
    console.log(err);
  };
  const { data: getSkuDetails } = useGetSkuDetail(
    "getSKudetails",
    params?.skuId,
    onSuccessGetSkuDetails,
    onErrorGetSkuDetails
  );

  const onSuccessGetAllMergedGuidelines = (res) => {
    if (res?.status === 200) {
      setAngleSets(res?.data?.data?.angleSets);
      setGuidelineId(res?.data?.data?._id);
      if (res?.data?.data?.angleSets?.length === 1) {
        segg_setSelectedVariant(res?.data?.data?.angleSets[0]);
        navigate(`/sequence-variant/${params?.skuId}/${res?.data?.data?._id}`);
      }
    }
  };
  const onErrorGetAllMergedGuidelines = (err) => {
    message.error(err?.message);
  };
  const { refetch: refetchGuidelines } = useGetAllMergedGuidelines(
    "getMergedGuidelines",
    segg_selectedCategory?.id,
    segg_selectedSubCategory?.id,
    segg_selectedMarketplace?.id,
    onSuccessGetAllMergedGuidelines,
    onErrorGetAllMergedGuidelines
  );
  return (
    <div className="select_variant_main_wrapper">
      <div className="select_variant_header">
        <div className="left_wrapper">
          <div className="content_wrapper">
            <div className="title">Category</div>
            <div className="title_value">{segg_selectedCategory?.name}</div>
          </div>
          <div className="content_wrapper">
            <div className="title">Sub Category</div>
            <div className="title_value">{segg_selectedSubCategory?.name}</div>
          </div>
        </div>
        <div className="right_wrapper">
          <div className="content_wrapper">
            <div className="title">Marketplace</div>
            <div className="market_place_wrapper">
              {skuDetails?.toProcessFilesDraft?.length > 0 &&
                skuDetails?.toProcessFilesDraft?.map((marketplace, index) => {
                  return (
                    <>
                      <div
                        className={`marketplace_title ${
                          marketplace?.isCompleted ||
                          segg_selectedMarketplace?.id ===
                            marketplace?.marketplace?._id
                            ? "active_marketplace"
                            : ""
                        }`}
                        key={marketplace?.marketplace?._id}
                      >
                        {marketplace?.marketplace?.name}
                      </div>
                      {skuDetails?.toProcessFilesDraft?.length - 1 !==
                        index && <div className="continue_line" />}
                    </>
                  );
                })}
            </div>
          </div>
        </div>
      </div>
      <div className="select_variant_content_wrapper">
        <div className="left_container">
          <div className="content_wrapper">
            <div className="title">Input</div>
            <div className="images_list_wrapper">
              {skuFiles.length > 0 &&
                skuFiles.map((skuFile, index) => {
                  return (
                    <div className="image_wrapper" key={`skuFile${index}`}>
                      <img
                        src={skuFile?.image?.thumbPath.url}
                        alt={skuFile?.image?.name}
                      />
                    </div>
                  );
                })}
            </div>
          </div>
        </div>
        <div className="right_container">
          <div className="content_wrapper">
            <div className="title">
              {segg_selectedMarketplace?.name} Image Sequence
              {richTextHtml && (
                <Link
                  onClick={() => {
                    window.open(richTextHtml);
                  }}
                >
                  View Batch Description
                </Link>
              )}
            </div>
            <div className="list_container">
              {angleSets?.length > 0 ? (
                angleSets?.map((item, index) => {
                  return (
                    <div className="variant_card_wrapper" key={index}>
                      <div className="variant_card_content">
                        <div className="variant_header">
                          <div className="card_title">Variant {index + 1}</div>
                          {segg_selectedVariant?._id === item?._id ? (
                            <button
                              className="unselect_btn"
                              onClick={() => segg_setSelectedVariant("")}
                            >
                              UnSelect
                            </button>
                          ) : (
                            <button
                              className="select_btn"
                              onClick={() => {
                                segg_setSelectedVariant(item);
                                navigate(
                                  `/sequence-variant/${params?.skuId}/${guidelineId}`
                                );
                              }}
                            >
                              Select
                            </button>
                          )}
                        </div>
                        <div className="variant_images_list">
                          {item?.angles?.length > 0 &&
                            item?.angles?.map((angle, id) => {
                              return (
                                <div className="image_wrapper" key={id}>
                                  <div className="image">
                                    <img
                                      src={
                                        angle?.angleGlobal?.image?.thumbPath
                                          ?.url
                                      }
                                      alt=""
                                    />
                                  </div>
                                  <div className="image_title">
                                    {angle?.adaptation?.name}
                                  </div>
                                </div>
                              );
                            })}
                        </div>
                      </div>
                    </div>
                  );
                })
              ) : (
                <div className="empty_container">
                  <Empty
                    description={
                      "No guidelines exist. Create a new guideline to view it here."
                    }
                  />
                </div>
              )}
            </div>
            <div className="action_container">
              <Stepper isSeggregation={true} activeStep={1} />

              {/* <Button
                width="195px"
                text="Next"
                height="55px"
                showIcon={true}
                iconImage={nextIcon}
                isDisabled={!segg_selectedVariant}
                handleClick={() =>
                  navigate(`/sequence-variant/${params?.skuId}/${guidelineId}`)
                }
              /> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default SelectVariant;
